import React from 'react';
import ApplicationActions from 'Components/ApplicationActions';
import NotificationManager from 'dom-managers/notification';
import { OUTBOARD, INBOARD, NON_POWERED } from 'constants/boatApplication';

export default class EngineTypeSelectScene extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      engineType: props.boat.engineType || '',
    };
  }

  handleSelectEngineType = engineType => () => {
    const { markStepAsRedacted, boat } = this.props;

    if (boat.status && boat.status !== 'DRAFT') {
      NotificationManager.error(400, 'Engine Type can only be changed in the application in the Draft status');
    } else {
      markStepAsRedacted();
      this.setState({ engineType });
    }
  };

  getSelectedEngineClass = type => {
    const { engineType } = this.state;

    return type === engineType ? 'selected' : '';
  };

  _isValidStep = () => {
    const { engineType } = this.state;

    return !!engineType;
  };

  handleMoveToNextStep = () => {
    const { engineType } = this.state;
    const { selectEngineType, goToStep } = this.props;

    if (this._isValidStep()) {
      selectEngineType(engineType);
      goToStep('next', true);
    } else {
      NotificationManager.error(1, 'No engine type', 'Please select boat engine type');
    }
  };

  handleMoveToArbitraryStep = stepId => {
    const { engineType } = this.state;
    const { selectEngineType, goToStep, stepIsChanged } = this.props;

    if (!stepIsChanged) {
      return goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
    }

    if (this._isValidStep()) {
      selectEngineType(engineType);
      goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
    } else {
      goToStep(typeof stepId === 'string' ? stepId : 'prev', false);
    }
  };

  render() {
    const { getNavBar, boat, getHeader } = this.props;
    const outboardIndex = boat.engineTypesList.indexOf(OUTBOARD);
    const inboardIndex = boat.engineTypesList.indexOf(INBOARD);
    const nonPoweredIndex = boat.engineTypesList.indexOf(NON_POWERED);

    return (
      <React.Fragment>
        {getHeader()}
        {getNavBar(this.handleMoveToNextStep, this.handleMoveToArbitraryStep)}
        <section className='engine-type-section'>
          {outboardIndex !== -1 && (
            <div
              className={`engine-type-banner outboard ${this.getSelectedEngineClass(OUTBOARD)}`}
              onClick={this.handleSelectEngineType(OUTBOARD)}
            >
              <div>OUTBOARD</div>
            </div>
          )}
          {inboardIndex !== -1 && (
            <div
              className={`engine-type-banner inboard ${this.getSelectedEngineClass(INBOARD)}`}
              onClick={this.handleSelectEngineType(INBOARD)}
            >
              <div>INBOARD / STERNDRIVE</div>
            </div>
          )}
          {nonPoweredIndex !== -1 && (
            <div
              className={`engine-type-banner non-powered ${this.getSelectedEngineClass(NON_POWERED)}`}
              onClick={this.handleSelectEngineType(NON_POWERED)}
            >
              <div>NON-POWERED</div>
            </div>
          )}
        </section>
        <ApplicationActions
          backButtonLabel='Prev. Step'
          backButtonAction={this.handleMoveToArbitraryStep}
          saveButtonLabel='Next Step'
          saveButtonAction={this.handleMoveToNextStep}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/EngineTypeSelect.jsx